module.exports = __webpack_public_path__ + "static/media/LaserWelding.8281f15b.png";